/* PROTOTYPING COMPONENTS */
import Proto from '../components/Prototyping/Proto';

const url_prefix = process.env.VUE_APP_URL_PREFIX;

export default [
  {
    path: url_prefix + '/proto',
    name: 'proto',
    component: Proto,
    meta: {
      requiresAuth: true,
      adminAuth: true,
    },
  },
];
